import { TreeNode } from '@circlon/angular-tree-component';
import { Component, AfterContentInit, AfterViewChecked, Input, ElementRef, ViewChild, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, HostBinding } from '@angular/core';
import { SLLayer, LayerTypeEnum } from 'src/app/model/sl-layer';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { Decorable } from 'src/app/types/decorable';
import { LegendViewComponent } from '../legend-view.component';

export interface ILegendItem {
  legendItem: Decorable;
}

@Component({
  selector: 'app-legend-item',
  templateUrl: './legend-item.component.html',
  styleUrls: ['./legend-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegendItemComponent implements AfterContentInit, OnDestroy, ILegendItem {

  @Input() layer: SLLayer;
  @Input() legendItem: Decorable = {};
  @Input() tree: LegendViewComponent;
  @Output() change: EventEmitter<any> = new EventEmitter();

  @ViewChild('legendContainer', { static: false }) legendContainer: ElementRef;
  @ViewChild('icon', { static: false }) icon: ElementRef;
  @ViewChild('childToggleWrapper', { static: true }) childToggleWrapper: ElementRef<HTMLSpanElement>;
  @ViewChild('childToggle', { static: true }) childToggle: ElementRef<HTMLSpanElement>;
  @HostBinding('class.hidden') hidden: boolean = false;
  @Output()
  public legend: Array<any> = [];
  public legendChange = new EventEmitter<Array<any>>();
  public includeInLegend = true;
  public closed = false;
  public legendIcon = '';
  public cb = 0;
  public needRender = false;
  public updated = true;
  public updatedChange = new EventEmitter<boolean>();
  private _ready = false;
  public get ready(): boolean {
    return this._ready;
  }
  public set ready(isReady: boolean) {
    this._ready = false;

    window.requestAnimationFrame(() => {
      this._ready = isReady;
      this.readyChange.emit(this._ready);
      this.legendChange.emit(this.legend);

    })

  }
  public get name(): string {
    return this.layer.name;
  }
  public readyChange = new EventEmitter<boolean>();

  constructor(private domNode: ElementRef, private layerAPI: LayerApiService, private cdr: ChangeDetectorRef) { }

  isCollection = false;
  ngAfterContentInit() {
    this.legendIcon = this.legendItem.data.icon;
    this.legendItem.data.component = this;
    if (this.layer.IsVirtual() === true) {
      // this.layer.icon;
      this.legendIcon = this.layer.icon;//'/assets/images/empty.png';
    }
    this.layer.legendChange.subscribe((event: any) => {
      event = null;
      this.ReflectInclusion();
    });
    this.layer.visChange.subscribe((event: any) => {
      event = null;
      this.ReflectInclusion();
    });
    this.isCollection = this.layer.geom.toLowerCase() === 'collection';
    if (this.isCollection) {
       /*(this.domNode.nativeElement).addEventListener('click', (event) => {
        this.Toggle(event);
        this.Refresh();
      });*/
    } else {
      /*$(this.domNode.nativeElement).on('click', (event) => {
        this.Toggle(event);
        this.Refresh();
      });**/
      if (this.layer.layerOn === false) {
        this.ReflectInclusion();
        return;
      }
      if (this.layer.IsVirtual() === true) {
        let isGeomInput = false;
        if (this.layer.type === LayerTypeEnum.Virtual_Input) {
          isGeomInput = ['rect', 'point'].indexOf(this.layer.inputType) > -1;
        }
        if ((this.layer.GetColor().split(';').pop() === 'inherit') && !isGeomInput) {

          this.layerAPI.GetLayerLegend(this.layer.GetSourceLayer()).then((legend) => {
            this.legend = legend;
            this.ready = true;
            this.legendChange.emit(this.legend);
            this.ReflectInclusion();
          });
        } else {
          this.layerAPI.GetVirtualSwatch(this.layer).then((legend) => {
            this.legend = legend;
            this.ready = true;

            this.legendChange.emit(this.legend);
            this.ReflectInclusion();
            this.HandleChange();

          });
        }
      } else {
        this.layerAPI.GetLayerLegend(this.layer).then((legend) => {
          this.legend = legend;
          this.ready = true;

          this.legendChange.emit(this.legend);
          this.ReflectInclusion();
        });
      }
    }
    this.ReflectInclusion();
  }
  ReflectInclusion() {
    let amVisible = false;
    if (this.legendItem.index === 'results') {
      if ((this.layer.includeInLegend === false) || (this.layer.layerOn === false)) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
      this.Refresh();
      return;
    }
    if (this.layer && (this.layer.includeInLegend === true && this.layer.layerOn === true)) {
      this.legendItem.show();
      if (this.isCollection) {
        this.HandleChange();
        this.Refresh();
        return;
      }
      amVisible = true;
    } else {
      this.legendItem.hide();
    }
    if (!!this.legendItem?.parent?.data?.component) {
      if (this.legendItem.parent.data.component.closed === true) {
        this.legendItem.hide();
        amVisible = false;
      }
    }
    if (!!this.legendItem?.hasChildren) {
      let visCount = 0;
      for (const child of this.legendItem.children) {
        if (!!child.data.layer && (child.data.layer.includeInLegend === true && child.data.layer.layerOn === true)) visCount += 1;
      }
      if (visCount === 0) {
        this.legendItem.hide();
        amVisible = false;
      }
    }
    /* if (!!this.legendItem?.parent?.data?.component) {
      this.legendItem?.parent?.data?.component.ReflectInclusion();
    }*/

    this.HandleChange();
    this.Refresh();

    // $(this.domNode.nativeElement).toggleClass('exclude',
    //	!(!!this.layer && (this.layer.includeInLegend === true) && (this.layer.layerOn === true)));
  }
  Toggle(event: any) {
    event = null;
    this.closed = !this.closed;
    // $('.legend-item', this.legendItem.parent.nativeElement).toggleClass('hidden');
    if (!!this.legendItem.children) {
      for (const child of this.legendItem.children) {
        child.data.component.ReflectInclusion();
      }
    }
    this.HandleChange();

    //$(this.legendContainer.nativeElement).toggleClass('hidden', this.closed);
  }
  HandleChange() {
    this.cdr.markForCheck();
    this.updated = false;
    this.updatedChange.emit(this.updated);
    this.Refresh();

    setTimeout(() => {
      this.updated = true;
      this.updatedChange.emit(this.updated);
      // $('img.icon-image', this.domNode.nativeElement).attr('src', this.GetIcon(this.legendItem.data));
      this.change.emit({ item: this });
      this.Refresh();

    }, 20)


  }
  GetFontIcon(_empty: '') {
    return 'collection-icon-wrapper font-icon ' + this.layer.fontIcon;
  }
  GetIcon(item) {
    this.cb = new Date().getTime();
    if (this.layer.IsVirtual()) {
      return this.legendIcon;
    }
    return item.icon + '/' + this.cb + '.png';
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    // do nothing yet
  }

}
